<div class="invitee-logo-wrapper">
  <img
    class="login-logo"
    src="assets/static/inpool__white.svg"
    alt="InPool Logo" />
</div>
<div
  class="register-form"
  *ngIf="employmentExternalTransferInfo">
  <div class="d-flex justify-content-between mb-4">
    <h1 class="register-form__title mb-2">
      {{ ("employment" | i18n) || "Einsatz" }}
    </h1>
    <span>
      {{ ("state" | i18n) || "Status" | titlecase }}:
      <b *ngIf="!employmentExternalTransferInfo.declined">{{
        ("jobStatusEnum." + employmentExternalTransferInfo.status | i18n) ||
          statusEnum[employmentExternalTransferInfo.status] | titlecase
      }}</b>
      <b *ngIf="employmentExternalTransferInfo.declined">{{
        ("declined" | i18n) || "Abgelehnt" | titlecase
      }}</b>
    </span>
  </div>
  <form
    class="register-form__form"
    [formGroup]="form"
    (ngSubmit)="submit()">
    <div>
      <div class="jobInfo__date">
        <div class="jobInfo__title-bold">
          {{
            employmentExternalTransferInfo.startDate
              | date: "EEEEEE. dd.MM.yyyy"
          }}
          -
          {{
            employmentExternalTransferInfo.endDate | date: "EEEEEE. dd.MM.yyyy"
          }}
        </div>
      </div>
      <div class="mb-2">
        {{ employmentExternalTransferInfo.departmentDisplayName }}
      </div>
      <div class="mb-2">
        {{ ("requiredEmployees" | i18n) || "Benötigte Mitarbeiter" }}:
        {{ employmentExternalTransferInfo.requiredUsers }}
      </div>
      <div class="mb-2">
        {{ ("workload" | i18n) || "Pensum" }}:
        {{ employmentExternalTransferInfo.workload + "%" }}
      </div>
      <div
        class="mb-2"
        *ngIf="employmentExternalTransferInfo.costCenter">
        {{ ("costCenter" | i18n) || "Kostenstelle" | titlecase }}:
        {{ employmentExternalTransferInfo.costCenter }}
      </div>
      <div
        class="mb-2"
        *ngIf="employmentExternalTransferInfo.description">
        {{ ("description" | i18n) || "Beschreibung" | titlecase }}:
        {{ employmentExternalTransferInfo.description }}
      </div>
      <div
        class="mb-2"
        *ngIf="
          employmentExternalTransferInfo.sex ||
          employmentExternalTransferInfo.sex === sexEnum.FEMALE
        ">
        {{ ("sex" | i18n) || "Geschlecht" | titlecase }}:
        <span *ngIf="employmentExternalTransferInfo.sex === sexEnum.FEMALE">
          {{ ("femaleSex" | i18n) || "Female" }}
        </span>
        <span *ngIf="employmentExternalTransferInfo.sex === sexEnum.MALE">
          {{ ("maleSex" | i18n) || "Male" }}
        </span>
      </div>
      <div
        class="mb-2"
        *ngIf="employmentExternalTransferInfo.certificates?.length">
        {{ ("qualifications" | i18n) || "Qualifikation" | titlecase }}:
        <span
          *ngFor="
            let certificate of employmentExternalTransferInfo.certificates
          ">
          <br />
          {{ certificate.displayName }}
        </span>
      </div>
      <div
        class="mb-2"
        *ngIf="employmentExternalTransferInfo.specialities?.length">
        {{ ("careSector" | i18n) || "Erfahrung / Pflegebereich" | titlecase }}:
        <span
          *ngFor="
            let speciality of employmentExternalTransferInfo.specialities
          ">
          <br />
          {{ speciality.displayName }}
        </span>
      </div>
      <div
        class="mb-2"
        *ngIf="
          employmentExternalTransferInfo.language ||
          employmentExternalTransferInfo.language === languageEnum.DEUTSCH
        ">
        {{ ("language" | i18n) || "Sprache" | titlecase }}:
        {{
          ("languageEnum." + employmentExternalTransferInfo.language | i18n) ||
            languageEnum[employmentExternalTransferInfo.language]
        }}
      </div>
      <div
        class="mb-2"
        *ngIf="
          employmentExternalTransferInfo.car ||
          employmentExternalTransferInfo.car ===
            carLicenseEnum.LICENSE_AVAILABLE
        ">
        {{ ("mobility" | i18n) || "Mobility" | titlecase }}:
        {{
          ("carLicenseEnum." + employmentExternalTransferInfo.car | i18n) ||
            carLicenseEnum[employmentExternalTransferInfo.car]
        }}
      </div>
      <div class="mt-5">
        <h3>
          {{ ("employees" | i18n) || "Mitarbeiter" | titlecase }}
        </h3>

        <ng-container
          *ngIf="employmentExternalTransferInfo.invitees.length > 0">
          <div
            class="d-flex justify-content-between align-items-center requested-users">
            <span>
              {{ ("name" | i18n) || "Name" | titlecase }}
            </span>
            <span>{{ ("state" | i18n) || "Status" | titlecase }}</span>
          </div>
          <div
            *ngFor="let invitee of employmentExternalTransferInfo.invitees"
            class="invitee"
            [attr.data-cy]="
              'invitee-fullName-' +
              invitee.personalData.firstName +
              ' ' +
              invitee.personalData.lastName
            ">
            <span>{{
              invitee.personalData.firstName +
                " " +
                invitee.personalData.lastName
            }}</span>
            <div class="d-flex align-items-center">
              <mat-icon
                [svgIcon]="getInviteeIcon(invitee)"
                [class]="getIconClass(invitee)"></mat-icon>
              <span
                class="ms-2"
                *ngIf="invitee.status === inviteeStatusEnum.POSSIBLE_CANDIDATE"
                >{{ ("submitted" | i18n) || "Eingereicht" | titlecase }}</span
              >
              <span
                class="ms-2"
                *ngIf="invitee.status === inviteeStatusEnum.DECLINED"
                >{{ ("declined" | i18n) || "Abgelehnt" | titlecase }}</span
              >

              <span
                class="ms-2"
                *ngIf="invitee.status === inviteeStatusEnum.BOOKED"
                >{{ ("booked" | i18n) || "Gebucht" | titlecase }}</span
              >
              <span
                class="ms-2"
                *ngIf="invitee.status === inviteeStatusEnum.CANCELLED"
                >{{ ("canceled" | i18n) || "Storniert" | titlecase }}</span
              >
            </div>
          </div>
        </ng-container>
        <div *ngIf="employmentExternalTransferInfo.invitees.length === 0">
          {{
            ("noEmployeesSubmitted" | i18n) || "Keine Mitarbeiter eingereicht"
          }}
        </div>
        <ng-container *ngIf="showForm">
          <div
            class="pt-5"
            *ngIf="
              employmentExternalTransferInfo &&
              employmentExternalTransferInfo.status === statusEnum.OPEN
            ">
            <h1 class="register-form__title mb-2">
              <ng-container
                *ngIf="
                  employmentExternalTransferInfo.preventDirectAccept;
                  else bookInviteeLabel
                ">
                {{
                  ("submitEmployees" | i18n) || "Mitarbeiter einreichen"
                    | titlecase
                }}
              </ng-container>
              <ng-template #bookInviteeLabel>
                {{ ("bookInvitee" | i18n) || "Mitarbeiter buchen" | titlecase }}
              </ng-template>
            </h1>

            <mat-form-field>
              <mat-label>{{ ("sex" | i18n) || "sex" | titlecase }}</mat-label>
              <mat-select
                [required]="
                  employmentExternalTransferInfo?.requiredFields?.sex || false
                "
                autofocus
                formControlName="sex">
                <mat-option [value]="sexEnum.FEMALE">{{
                  ("femaleSex" | i18n) || "female" | titlecase
                }}</mat-option>
                <mat-option [value]="sexEnum.MALE">{{
                  ("maleSex" | i18n) || "male" | titlecase
                }}</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="row">
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>{{ ("firstName" | i18n) || "Vorname" }}</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="firstName"
                    autocomplete="given-name" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>{{ ("lastName" | i18n) || "Nachname" }}</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="lastName"
                    autocomplete="family-name" />
                </mat-form-field>
              </div>
            </div>
            <mat-form-field>
              <mat-label>{{ ("email" | i18n) || "E-Mail" }}</mat-label>
              <input
                matInput
                type="email"
                formControlName="email"
                autocomplete="email"
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}" />
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{
                ("phoneNumber" | i18n) || "phone number" | titlecase
              }}</mat-label>
              <input
                matInput
                placeholder="+41791234567"
                type="phone"
                formControlName="phone"
                (keydown)="trimPhone()"
                autocomplete="tel" />
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{
                ("dateOfBirth" | i18n) || "Geburtstag" | titlecase
              }}</mat-label>
              <input
                matInput
                [value]="dateOfBirth ? (dateOfBirth | date) : ''"
                readonly
                [attr.required]="
                  employmentExternalTransferInfo?.requiredFields?.dateOfBirth ||
                  false
                "
                (click)="dateOfBirthDatePicker.open()" />
              <input
                matInput
                name="user-date-of-birth-datepicker"
                (dateChange)="selectDateOfBirth($event)"
                (click)="dateOfBirthDatePicker.open()"
                (keydown)="(false)"
                [matDatepicker]="dateOfBirthDatePicker"
                hidden />
              <mat-datepicker-toggle
                matSuffix
                [for]="dateOfBirthDatePicker"></mat-datepicker-toggle>
              <button
                *ngIf="
                  dateOfBirth &&
                  !employmentExternalTransferInfo?.requiredFields?.dateOfBirth
                "
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="clearDateOfBirth()">
                <mat-icon svgIcon="close"></mat-icon>
              </button>
              <mat-datepicker #dateOfBirthDatePicker></mat-datepicker>
            </mat-form-field>
            <div class="mb-4">
              <employment-mini-availability-match
                *ngIf="!loadingAvailabilities"
                [externalAvailabilities]="availabilities"
                [fromDate]="fromDate"
                [toDate]="toDate"
                [availabilityPercentage]="matchPercentage">
              </employment-mini-availability-match>
              <div
                *ngFor="let availability of availabilities; let i = index"
                class="invitee-availability-list-item"
                [class.available]="
                  availability.status === availabilityStatusEnum.AVAILABLE
                "
                [class.unavailable]="
                  availability.status === availabilityStatusEnum.UNAVAILABLE
                ">
                <div class="invitee-availability-dates">
                  <span
                    >{{ availability.startDate | date: "EEEEEE. dd.MM.yyyy" }} -
                    {{
                      availability.endDate | date: "EEEEEE. dd.MM.yyyy"
                    }}</span
                  >
                  <button
                    class="edit-invitee-availability-button custom-icon-button"
                    mat-button
                    type="button"
                    (click)="openAvailabilityDialog(availability)"
                    data-cy="remove-invitee-availability-button">
                    <mat-icon
                      class="custom-icon-button-icon"
                      svgIcon="pencil-outline"></mat-icon>
                  </button>
                </div>
                <div class="invitee-availability-remove-to">
                  <button
                    class="remove-invitee-availability-button text-icon-button"
                    mat-button
                    type="button"
                    (click)="removeAvailability(availability)"
                    data-cy="remove-invitee-availability-button">
                    <mat-icon
                      class="text-icon-button-icon"
                      svgIcon="close"></mat-icon>
                    <span>{{
                      ("removeAvailabilityField" | i18n) ||
                        "Verfügbarkeit entfernen"
                    }}</span>
                  </button>
                </div>
              </div>
              <button
                class="add-invitee-availability-button text-icon-button"
                mat-button
                type="button"
                (click)="openAvailabilityDialog()"
                data-cy="add-invitee-availability-button">
                <mat-icon
                  class="text-icon-button-icon"
                  svgIcon="plus"></mat-icon>
                <span>{{
                  ("addAvailabilityField" | i18n) ||
                    "Weitere Verfügbarkeit hinzufügen"
                }}</span>
              </button>
            </div>
            <app-certificate-select
              [required]="
                employmentExternalTransferInfo?.requiredFields?.certificates ||
                false
              "
              [selectedMappedCertificates]="
                form?.controls?.certificates?.value || []
              "
              (selectionChanged)="
                certificateSelectionChanged($event)
              "></app-certificate-select>
            <app-speciality-select
              [selectedMappedSpecialities]="
                form?.controls?.specialities?.value || []
              "
              (selectionChanged)="
                specialitySelectionChanged($event)
              "></app-speciality-select>

            <ng-container *ngIf="employmentExternalTransferInfo.enableFiles">
              <app-upload-file
                *ngIf="!files?.length"
                [isUploading]="isUploading"
                (inputEvent)="uploadFile($event)"></app-upload-file>

              <div *ngIf="!isUploading && !isDownloading && files?.length">
                <ng-container>
                  <div *ngIf="files?.length">
                    <div
                      class="file-list-item"
                      *ngFor="let file of files">
                      <button
                        type="button"
                        mat-button
                        (click)="downloadInviteeFile($event, file)">
                        <mat-icon svgIcon="download"></mat-icon>
                        <span>{{ file.fileName }} </span>

                        <mat-icon
                          *ngIf="progressbarValue === 100"
                          class="color-success mat-button-small-icon"
                          svgIcon="check-circle"></mat-icon>
                      </button>
                      <small
                        >{{
                          $any(file.size) / (1024 * 1024) | number: "1.0-3"
                        }}
                        MB / {{ file.type | uppercase }} /
                        {{ file.updatedAt | date: "short" }}
                      </small>
                      <button
                        type="button"
                        mat-button
                        class="file-list-item__delete-button"
                        (click)="removeFileDialog(file, deleteConfirm)">
                        <mat-icon svgIcon="close"></mat-icon>
                      </button>
                    </div>
                  </div>
                </ng-container>
              </div>
              <mat-progress-bar
                *ngIf="isDownloading"
                mode="determinate"
                [value]="progressbarValue"></mat-progress-bar>
            </ng-container>
            <br />
          </div>
        </ng-container>

        <br />
        <div class="row action-button">
          <div
            class="col col-6"
            *ngIf="
              employmentExternalTransferInfo.status === statusEnum.OPEN &&
              !canNotDeclineJob
            ">
            <button
              mat-button
              color="warn"
              type="button"
              (click)="declineTransfer()"
              data-cy="decline-job"
              data-gtm-label="Dienst ablehnen">
              {{ ("declineEmployment" | i18n) || "decline job" | uppercase }}
            </button>
          </div>
          <div class="col col-6">
            <button
              *ngIf="
                showForm &&
                employmentExternalTransferInfo.status === statusEnum.OPEN
              "
              mat-button
              color="primary"
              type="submit"
              class="mat-button-block"
              [class.disabled]="
                form?.invalid ||
                (employmentExternalTransferInfo.enableFiles && !files.length) ||
                !availabilities.length ||
                (employmentExternalTransferInfo.requiredFields?.certificates &&
                  !form?.controls?.certificates?.value?.length) ||
                (employmentExternalTransferInfo.requiredFields?.sex &&
                  (form?.controls?.sex?.value === undefined ||
                    form?.controls?.sex?.value === null)) ||
                (employmentExternalTransferInfo.requiredFields?.dateOfBirth &&
                  !dateOfBirth)
              "
              [disabled]="
                form?.invalid ||
                (employmentExternalTransferInfo.enableFiles && !files.length) ||
                !availabilities.length ||
                (employmentExternalTransferInfo.requiredFields?.certificates &&
                  !form?.controls?.certificates?.value?.length) ||
                (employmentExternalTransferInfo.requiredFields?.sex &&
                  (form?.controls?.sex?.value === undefined ||
                    form?.controls?.sex?.value === null)) ||
                (employmentExternalTransferInfo.requiredFields?.dateOfBirth &&
                  !dateOfBirth) ||
                false
              ">
              <span>
                <ng-container
                  *ngIf="
                    employmentExternalTransferInfo.preventDirectAccept;
                    else bookInviteeLabel
                  ">
                  {{
                    ("submitPossibleCandidate" | i18n) || "Kandidat einreichen"
                      | uppercase
                  }}
                </ng-container>
                <ng-template #bookInviteeLabel>
                  {{ ("book" | i18n) || "Buchen" | uppercase }}
                </ng-template>
              </span>
            </button>
            <button
              *ngIf="
                !showForm &&
                employmentExternalTransferInfo.status === statusEnum.OPEN
              "
              mat-button
              color="primary"
              class="mat-button-block"
              data-cy="open-form-button"
              (click)="showForm = true">
              <span>
                <ng-container
                  *ngIf="
                    employmentExternalTransferInfo.preventDirectAccept;
                    else bookInviteeLabel
                  ">
                  {{
                    ("submitEmployees" | i18n) || "Mitarbeiter einreichen"
                      | uppercase
                  }}
                </ng-container>
                <ng-template #bookInviteeLabel>
                  {{
                    ("bookInvitee" | i18n) || "Mitarbeiter buchen" | uppercase
                  }}
                </ng-template>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!employmentExternalTransferInfo">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </form>
</div>
<ng-template #deleteConfirm>
  <h2 mat-dialog-title>
    {{ ("deleteFileConfirmTitle" | i18n) || "Remove this document?" }}
  </h2>
  <mat-dialog-content>
    {{
      ("deleteFileConfirmContent" | i18n) ||
        "This will delete this document and cannot be undone"
    }}
    <br /><br />
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
      mat-flat-button
      mat-dialog-close
      type="button">
      {{ ("cancel" | i18n) || "cancel" | titlecase }}
    </button>
    <button
      mat-flat-button
      color="warn"
      type="button"
      [mat-dialog-close]="true">
      {{ ("remove" | i18n) || "remove" | titlecase }}
    </button>
  </mat-dialog-actions>
</ng-template>
